const BaseItemsPerPageOptions = [
  10,
  20,
  30,
  50,
  100,
];

export default BaseItemsPerPageOptions;
